import { Alert, Button, Stack, Text } from "@mantine/core";
import { IconLock } from "@tabler/icons-react";
import { useState } from "react";

import { useFreshAuth } from "../hooks/useFreshAuth";

export function FreshAuthRequired() {
	const { signInAgain } = useFreshAuth();
	const [isSigningOut, setIsSigningOut] = useState(false);

	const handleSignInAgain = async () => {
		setIsSigningOut(true);
		await signInAgain();
	};

	return (
		<Alert color="blue" variant="light" icon={<IconLock size={16} />}>
			<Stack gap="sm" align="flex-start">
				<Text size="sm" fw={500}>
					For your security, sign in again
				</Text>
				<Text size="xs">
					Changing your sign-in and security settings requires a recent sign-in.
				</Text>
				<Button size="xs" onClick={handleSignInAgain} loading={isSigningOut}>
					Sign in again
				</Button>
			</Stack>
		</Alert>
	);
}
